export function getFileSignature(file: File) {
  return `${file.name}:${file.size}:${file.lastModified}`
}

export function mergeUniqueFiles(currentFiles: File[], nextFiles: File[]) {
  const signatures = new Set(currentFiles.map(getFileSignature))
  const uniqueNextFiles = nextFiles.filter((file) => {
    const signature = getFileSignature(file)
    if (signatures.has(signature)) {
      return false
    }

    signatures.add(signature)
    return true
  })

  return [...currentFiles, ...uniqueNextFiles]
}

export function renameFile(file: File, nextName: string) {
  return new File([file], nextName, {
    lastModified: file.lastModified,
    type: file.type,
  })
}

export function getReadableFileSize(bytes: number) {
  if (bytes < 1024) {
    return `${bytes} B`
  }

  const kilobytes = bytes / 1024
  if (kilobytes < 1024) {
    return `${kilobytes.toFixed(1)} KB`
  }

  return `${(kilobytes / 1024).toFixed(1)} MB`
}

export function splitFileName(fileName: string) {
  const extensionIndex = fileName.lastIndexOf('.')
  if (extensionIndex <= 0) {
    return { baseName: fileName, extension: '' }
  }

  return {
    baseName: fileName.slice(0, extensionIndex),
    extension: fileName.slice(extensionIndex),
  }
}
